import React from "react";
import { Query, withApollo } from 'react-apollo';
import Form from "../form/Form";
import { AsyncStorage } from "react-native";

const FragmentInspect = props => {
  const queryData = props.client.readFragment(props.fragment);

  return (
    <Form {...props} initialValues={queryData}>
      {form => props.children(queryData, form)}
    </Form>
  );
};

export default withApollo(FragmentInspect);
